{{this.content}}
<span [style.animation-duration]="2 * this.delay + 'ms'" *ngIf="this.showCursor" class="cursor"></span>
